import { useFeatureVariant } from "@src/context/FeatureFlagContext";

export const COMBINED_FIND_PROVIDER_FEATURE = "COMBINED_FIND_PROVIDER" as const;

/** A single routing decision shared by both entry points. */
export const useIsCombinedFindProviderTreatment = (): boolean =>
  useFeatureVariant(COMBINED_FIND_PROVIDER_FEATURE) === "treatment";
